
import { useCompoundBody } from "@react-three/cannon";
import { useRef } from "react";
import { Group } from "three";
import { useDragConstraint, ObjectProps, Box } from "../utils";

const Part = ({position, rotation}: ObjectProps) => {
  return (
    <group position={position} rotation={rotation}>
      <Box position={[0, -1, 0]} args={[0.1, 0.5, 3]} />
      <Box position={[0, -0.4, 1.35]} args={[0.1, 1.5, 0.3]} />
      <Box position={[0, 1, -1]} args={[0.1, 4, 0.5]} />
    </group>
  );
};

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useCompoundBody(() => ({
    mass: 150,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { type: 'Box', mass: 70, position: [1.2, -1, 0], args: [0.1, 0.5, 3] },
      { type: 'Box', position: [1.2, -0.4, 1.35], args: [0.1, 1.5, 0.3] },
      { type: 'Box', position: [1.2, 1, -1], args: [0.1, 4.5, 0.5] },

      { type: 'Box', mass: 70, position: [-1.2, -1, 0], args: [0.1, 0.5, 3] },
      { type: 'Box', position: [-1.2, -0.4, 1.35], args: [0.1, 1.5, 0.3] },
      { type: 'Box', position: [-1.2, 1, -1], args: [0.1, 4.5, 0.5] }
    ], 
    material: {
      friction: 0.6, // memo: ギターとの適度な摩擦力
      restitution: 0.05, // memo: 非常に低い反発係数で安定性を向上
    },
    linearDamping: 0.5, // memo: 線形減衰でスタンドの振動を抑制
    angularDamping: 0.5, // memo: 角度減衰でスタンドの回転振動を抑制
    type: 'Dynamic',
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind}>

      <Part position={[ 0.8, 0, 0]} rotation={[0, 0,  Math.PI / 12]} />
      <Part position={[-0.8, 0, 0]} rotation={[0, 0, -Math.PI / 12]} />
    </group>
  );
};
